import SiafLiteApiRepository from "../../external/siafLiteApi";

class ParametrosAliquotaService {
  constructor() {
    this.urlBase = "/estoque/parametros-aliquota";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filtros) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filtros);
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAllAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }
}

export default ParametrosAliquotaService;
